/* global jQuery, document */
import anime from 'animejs/lib/anime.es';
import compact from 'lodash/compact';
import imagesLoaded from 'imagesloaded';
import map from 'lodash/fp/map';
import scrollDetector from 'scroll-detector';
import shuffle from 'lodash/shuffle';

(($) => {
  $(once('friends.animations', 'body')).each(() => {
    /* global IntersectionObserver, document, window */
    if (window.IntersectionObserver) {
      // Multi image campaign banner
      /*if (document.querySelector('.paragraph--type-campaign-banner-multi')) {
        const observer = new IntersectionObserver(
          (entries) => {
            map((entry) => {
              const { isIntersecting, target } = entry;
              if (isIntersecting) {
                const images = target.querySelectorAll('.paragraph--type-campaign-banner-image');
                if (images) {
                  const numbers = shuffle(compact([...Array(7).keys()]));
                  map((image) => {
                    const delay = numbers.pop();
                    imagesLoaded(target, () => {
                      setTimeout(() => {
                        image.classList.add('background-is-loaded');
                      }, delay * 250);
                    });
                  }, images);
                }
              }
            }, entries);
          },
          {
            threshold: 0.4,
          },
        );
        map(p => observer.observe(p), document.querySelectorAll('.paragraph--type-campaign-banner-multi'));
      }*/

      // Doughnut charts
      if (document.querySelector('.doughnut-chart')) {
        const donutObserver = new IntersectionObserver(
          (entries) => {
            map((entry) => {
              const { isIntersecting, target } = entry;
              // First check that the element is intersecting
              if (isIntersecting) {
                const percent = target.getAttribute('data-percent');
                const foreground = target.querySelector('.circle-foreground');
                if (foreground) {
                  foreground.style['stroke-dashoffset'] = percent;
                }
              }
            }, entries);
          },
          {
            threshold: 0.4,
          },
        );
        map(p => donutObserver.observe(p), document.querySelectorAll('.doughnut-chart'));
      }

      // Text Callout Rule
      if (document.querySelector('.paragraph--type-text-callout')) {
        const calloutObserver = new IntersectionObserver(
          (entries) => {
            map((entry) => {
              const { isIntersecting, target } = entry;
              // First check that the element is intersecting
              if (isIntersecting) {
                const rule = target.querySelector('.callout-rule');
                if (rule) {
                  rule.style.width = '100%';
                }
              }
            }, entries);
          },
          {
            threshold: 0.4,
          },
        );
        map(p => calloutObserver.observe(p), document.querySelectorAll('.paragraph--type-text-callout'));
      }

      // CTA Fade-in
      if (document.querySelector('.paragraph--type-call-to-action')) {
        const fadeObserver = new IntersectionObserver(
          (entries) => {
            map((entry) => {
              const { isIntersecting, target } = entry;
              // First check that the element is intersecting
              if (isIntersecting) {
                const rule = target.querySelector('.field--name-field-short-handwriting-text');
                if (rule) {
                  rule.style.opacity = '1';
                }
              }
            }, entries);
          },
          {
            threshold: 0.4,
          },
        );
        map(p => fadeObserver.observe(p), document.querySelectorAll('.paragraph--type-call-to-action'));
      }

      // Layered component types that need is-loaded class when entering the
      // viewport
      if (document.querySelector('.paragraph--type-book-shape-half-image') ||
          document.querySelector('.paragraph--type-quote-with-book') ||
          document.querySelector('.paragraph--type-campaign-banner-single') ||
          document.querySelector('.paragraph--type-column') ||
          document.querySelector('.paragraph--type-full-image')) {
        const types = [
          '.paragraph--type-book-shape-half-image',
          '.paragraph--type-quote-with-book',
          '.paragraph--type-campaign-banner-single',
          '.paragraph--type-column',
          '.paragraph--type-full-image',
        ];
        const observer = new IntersectionObserver(
          (entries) => {
            map((entry) => {
              const { isIntersecting, target } = entry;
              // First check that the element is intersecting
              if (isIntersecting) {
                target.classList.add('is-loaded');
              }
            }, entries);
          },
          {
            threshold: 0.4,
          },
        );
        map(p => observer.observe(p), document.querySelectorAll(types.join(',')));
      }
    }

    const pageScrolled = () => {
      const logo = document.querySelector('.navbar-brand svg');
      const socialLinks = document.querySelector('#block-sociallinks');
      const searchForm = document.querySelector('#block-searchform');
      const { height } = socialLinks.getBoundingClientRect();
      anime({
        targets: [logo],
        width: 194,
        height: 83.4 * (194 / 257.7),
        easing: 'linear',
        duration: 300,
      });
      anime({
        targets: [socialLinks, searchForm],
        translateY: -1 * height,
        duration: 300,
        easing: 'linear',
      });

      const alert = document.querySelector('#block-sitealerts .alert.show');
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0,
      );
      if (alert && vw >= 1024) {
        document.body.classList.remove('alert-displayed');
        const { height: alertHeight } = alert.getBoundingClientRect();
        anime({
          targets: [alert],
          translateY: -1 * alertHeight,
          duration: 300,
          easing: 'linear',
        });
      }
    };

    const pageAtTop = () => {
      const logo = document.querySelector('.navbar-brand svg');
      const socialLinks = document.querySelector('#block-sociallinks');
      const searchForm = document.querySelector('#block-searchform');
      anime({
        targets: [logo],
        width: 257.7,
        height: 83.4,
        easing: 'linear',
        duration: 300,
      });
      anime({
        targets: [socialLinks, searchForm],
        translateY: 0,
        duration: 300,
        easing: 'linear',
      });

      const alert = document.querySelector('#block-sitealerts .alert.show');
      if (alert) {
        document.body.classList.add('alert-displayed');
        anime({
          targets: [alert],
          translateY: 0,
          duration: 300,
          easing: 'linear',
        });
      }
    };

    if (!scrollDetector.isPageTop()) {
      const { body } = document;
      body.classList.add('small-nav');
      pageScrolled();
    }

    scrollDetector.on('scroll:down', () => {
      const { body } = document;
      if (!body.classList.contains('small-nav')) {
        body.classList.add('small-nav');
        pageScrolled();
      }
    });

    scrollDetector.on('at:top', () => {
      const { body } = document;
      if (body.classList.contains('small-nav')) {
        body.classList.remove('small-nav');
        pageAtTop();
      }
    });
  });
})(jQuery);
